// A FirestoreError carries only a code and message — nothing says which read or
// write failed, so every "Missing or insufficient permissions" in GlitchTip
// looks the same. The wrappers in firestore.ts record the op and path of each
// failure here; sentry.ts turns it into tags and a per-collection fingerprint.
export interface FirestoreErrorContext {
  op: string
  path: string
}

const contexts = new WeakMap<object, FirestoreErrorContext>()

export function tagFirestoreError<E>(err: E, op: string, path: string): E {
  if (err && typeof err === 'object' && !contexts.has(err)) contexts.set(err, { op, path })
  return err
}

export function firestoreErrorContext(err: unknown): FirestoreErrorContext | undefined {
  return err && typeof err === 'object' ? contexts.get(err) : undefined
}

// `groups/abc/totems/xyz` → `groups/totems`: the collection chain without ids,
// so failures group per collection rather than per document.
export function collectionOf(path: string): string {
  return path.split('/').filter((_, i) => i % 2 === 0).join('/')
}
